import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import { useMemo, useState } from 'react';
import { SubMenu } from 'react-pro-sidebar';
import { useLocation } from 'react-router-dom';

const SidebarSubMenu = ({ menuItem, currentLevel, sidebarIsCollapsed, children }) => {
    const { label, icon, testId } = menuItem;
    const location = useLocation();

    const foundActiveChildren = useMemo(() => {
        const checkForActiveChildren = (children) => {
            if (!children) {
                return false;
            }

            for (const child of children) {
                if (location.pathname.startsWith(child.link)) {
                    return true;
                }

                if (child.children) {
                    if (checkForActiveChildren(child.children)) {
                        return true;
                    }
                }
            }

            return false;
        };

        return checkForActiveChildren(menuItem.children);
    }, [menuItem.children, location.pathname]);

    const [open, setOpen] = useState(foundActiveChildren);

    const onOpenChange = (newOpen) => {
        setOpen(newOpen);
    };

    return (
        <SubMenu
            data-testid={testId}
            style={{
                paddingLeft: currentLevel === 0 ? '8px' : `${currentLevel * 40}px`,
            }}
            suffix={
                <IconButton>
                    <ExpandMoreIcon
                        sx={{
                            transform: open ? '' : 'rotate(-90deg)',
                            transition: 'transform 0.1s ease-in-out',
                        }}
                    />
                </IconButton>
            }
            active={foundActiveChildren && (sidebarIsCollapsed || !open)}
            label={label}
            icon={icon}
            open={open}
            onOpenChange={onOpenChange}
        >
            {children}
        </SubMenu>
    );
};

export default SidebarSubMenu;
